import React from 'react'
import { IconProps } from '../types'

export default function ChartBarsIcon({
    className = 'h-[14px] w-[14px]',
    fill = '#0A84FF',
    ...props
}: IconProps) {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                d="M11.0846 1.16602H2.91797C1.9263 1.16602 1.16797 1.92435 1.16797 2.91602V11.0827C1.16797 12.0743 1.9263 12.8327 2.91797 12.8327H11.0846C12.0763 12.8327 12.8346 12.0743 12.8346 11.0827V2.91602C12.8346 1.92435 12.0763 1.16602 11.0846 1.16602ZM4.66797 9.91602C4.66797 10.266 4.43464 10.4993 4.08464 10.4993C3.73464 10.4993 3.5013 10.266 3.5013 9.91602V7.58268C3.5013 7.23268 3.73464 6.99935 4.08464 6.99935C4.43464 6.99935 4.66797 7.23268 4.66797 7.58268V9.91602ZM7.58464 9.91602C7.58464 10.266 7.3513 10.4993 7.0013 10.4993C6.6513 10.4993 6.41797 10.266 6.41797 9.91602V4.08268C6.41797 3.73268 6.6513 3.49935 7.0013 3.49935C7.3513 3.49935 7.58464 3.73268 7.58464 4.08268V9.91602ZM10.5013 9.91602C10.5013 10.266 10.268 10.4993 9.91797 10.4993C9.56797 10.4993 9.33463 10.266 9.33463 9.91602V6.41602C9.33463 6.06602 9.56797 5.83268 9.91797 5.83268C10.268 5.83268 10.5013 6.06602 10.5013 6.41602V9.91602Z"
                fill={fill}
            />
        </svg>
    )
}
